<template>
  <div class="organizeFilterPills">
    <neb-pill-group :items="filterLabels"
      wrap
      itemsClearable
      @clear="onClear"
      @clear-all="$emit('clear-all')"
    ></neb-pill-group>
  </div>
</template>

<script>
import { includes, isNull, isEmpty, isUndefined } from 'lodash'

const displayFilterKeys = [
  'topics', 'keywords', 'customProperties',
  'collection'
]

export default {
  name: 'OrganizeFilterPills',

  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    applicableFilters () {
      return Object.keys(this.filters)
        .filter(key => includes(displayFilterKeys, key))
        .filter(key =>
          !isNull(this.filters[key]) &&
          !isEmpty(this.filters[key]) &&
          !isUndefined(this.filters[key])
        )
        .reduce((obj, key) => {
          obj[key] = this.filters[key]
          return obj
        }, {})
    },
    filterLabels () {
      return Object.keys(this.applicableFilters)
        .map(key => {
          if (Array.isArray(this.filters[key])) {
            return this.filters[key]
              .map(v => `${key}: ${v}`)
          } else {
            return `${key}: ${this.filters[key]}`
          }
        })
        .reduce((acc, item) => {
          if (Array.isArray(item)) {
            item.forEach(v => { acc.push(v) })
          } else {
            acc.push(item)
          }

          return acc
        }, [])
    }
  },

  methods: {
    onClear ({ item }) {
      const [ key, value ] = item.split(':')
        .map(i => i.trim())

      this.$emit('clear', { key, value })
    }
  }
}
</script>

<style lang="scss">
</style>
